<template>
  <v-list-item>
    <v-list-tile router :href="route" exact>
      <v-list-tile-action>
        <v-icon>{{ icon }}</v-icon>
      </v-list-tile-action>
      <v-list-tile-content>
        <v-list-tile-title>
          {{ title }}
        </v-list-tile-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list-item>
</template>

<script>
  export default {
    props: {
      route: {
        type: Object,
        required: true
      },
      icon: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ApplicationMenuItem.vue